import axios from 'axios'

export default class Product {
    static getAll (path) {
        return new Promise((resolve, reject) => {
            axios.get(`${path}`)
                .then(({data}) => resolve(data))
                .catch(err => reject(err))
        })
    }

    static settings (path) {
        return new Promise((resolve, reject) => {
            axios.get(`${path}`)
                .then(({data}) => resolve(data))
                .catch(err => reject(err))
        })
    }

    static getById (path, id) {
        return new Promise((resolve, reject) => {
            axios.get(`${path}/${id}`)
                .then(({data}) => resolve(data))
                .catch(err => reject(err))
        })
    }
}



// WEBPACK FOOTER //
// ./src/services/product.js